import React from "react";
import { Link } from "react-router-dom";

const partners = [
	{ src: "/images/seneca.png", alt: "Seneca Dairy Systems" },
	{ src: "/images/double-l.png", alt: "Double L Group LLC" },
	{ src: "/images/shady-lane.png", alt: "Shady Lane Curtains LLC" },
	{ src: "/images/skov-secc.png", alt: "SKOV-SECCO" },
	{ src: "/images/auto-vent.png", alt: "AutoVent LLC" },
];

function Footer() {
	const currentYear = new Date().getFullYear();
	const imageSrc = (path) => process.env.PUBLIC_URL + path;

	return (
		<footer className="bg-[#071428] text-white">
			<div className="mx-auto grid max-w-7xl gap-10 px-6 py-12 sm:grid-cols-2 lg:grid-cols-4">
				<div>
					<Link to="/" className="inline-block">
						<img
							src={imageSrc("/images/logo.png")}
							alt="Mid-State Ag Supply"
							className="h-14 w-auto"
						/>
					</Link>
					<p className="mt-4 max-w-xs text-sm leading-relaxed text-gray-400">
						Improving dairy farm productivity and livestock comfort
						with professional barn ventilation, curtains, and custom
						engineered layouts.
					</p>
				</div>

				<div>
					<h3 className="text-sm font-semibold tracking-[0.14em]">
						BUSINESS HOURS
					</h3>
					<div className="mt-4 flex items-start gap-3">
						<i className="fa-solid fa-clock mt-1 text-primary"></i>
						<div className="text-sm">
							<p className="font-semibold">Monday – Friday</p>
							<p className="text-gray-400">8:00 AM – 5:00 PM</p>
						</div>
					</div>
				</div>

				<div>
					<h3 className="text-sm font-semibold tracking-[0.14em]">
						CONTACT DETAILS
					</h3>
					<div className="mt-4 space-y-3 text-sm">
						<a
							href="tel:715-255-2355"
							className="flex items-center gap-3 transition hover:text-tertiary"
						>
							<i className="fa-solid fa-phone w-4 text-center text-primary"></i>
							715-255-2355
						</a>
						<a
							href="mailto:glenn.midstateagsupply@gmail.com"
							className="flex items-start gap-3 text-gray-400 transition hover:text-white"
						>
							<i className="fa-solid fa-envelope mt-0.5 w-4 text-center text-primary"></i>
							<span className="break-all">
								glenn.midstateagsupply@gmail.com
							</span>
						</a>
						<p className="flex items-start gap-3 text-gray-400">
							<i className="fa-solid fa-location-dot mt-0.5 w-4 text-center text-primary"></i>
							N12580 Owen Ave, Owen WI 54460
						</p>
					</div>
				</div>

				<div>
					<h3 className="text-xs font-semibold tracking-[0.16em] text-gray-400">
						IN PARTNERS WITH
					</h3>
					<div className="mt-4 grid grid-cols-2 gap-2 lg:grid-cols-1">
						{partners.map((partner) => (
							<div
								key={partner.alt}
								className="flex min-h-[52px] items-center justify-center rounded-lg bg-white px-3 py-2"
							>
								<img
									src={imageSrc(partner.src)}
									alt={partner.alt}
									className="max-h-10 w-auto object-contain"
								/>
							</div>
						))}
					</div>
				</div>
			</div>

			<div className="border-t border-white/10">
				<div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-4 text-xs text-gray-500 md:flex-row">
					<p>
						© Copyright {currentYear} Mid-State Ag Supply LLC. All
						Rights Reserved.
					</p>
					<div className="flex gap-6">
						<span>Privacy Policy</span>
						<span>Terms of Service</span>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
